export const GET_PAGE_DATA = "GET_PAGE_DATA";
